import { useEffect } from 'react';

import {
  useNylasCalendarInterviewType,
  useNylasCalendarManageConnectionModal,
} from '@/features/nylas-calendar-manage-connection-modal';
import { GlobalDialogType } from '@/stores/global-dialogs/global-dialogs.store.types';
import { useGlobalDialogData } from '@/stores/global-dialogs/hooks/useGlobalDialogData';
import { useIsGlobalDialogOpen } from '@/stores/global-dialogs/hooks/useIsGlobalDialogOpen';

export const NylasCalendarConnectionModal = () => {
  const isVisible = useIsGlobalDialogOpen(GlobalDialogType.NylasCalendarManageConnectionModal);
  const data = useGlobalDialogData({ dialogType: GlobalDialogType.NylasCalendarManageConnectionModal, isVisible });

  const interviewType = useNylasCalendarInterviewType();
  const nylasCalendar = useNylasCalendarManageConnectionModal({
    initialInterviewType: interviewType,
    skipManageConnection: data?.skipManageConnection,
    footer: data?.footer,
    onFinish: data?.onFinish,
    onCancel: data?.onCancel,
  });

  useEffect(() => {
    if (isVisible) {
      nylasCalendar.open();
    } else {
      nylasCalendar.close();
    }
  }, [isVisible]);

  return nylasCalendar.modal;
};
